import React, {Component} from 'react';
import _ from 'lodash';
import animateScrollTo from 'animated-scroll-to';
import createItems from '../utils/createItems'
import calculateItems from '../utils/calculateItems'
import {animation} from '../settings';
import MasonryWrapper from './MasonryWrapper';
import Glyph from './galleryItems/Glyph';
import Project from './galleryItems/Project/Project';
import Image from './galleryItems/Image';
import Loader from './Loader';

import './Gallery.css';


class Gallery extends Component {

  constructor(props){
    super(props);
    this.state = { items: null, openItem: null, firstLoad: false };
    this.toggleProject = this.toggleProject.bind(this);
    this.updateProject = this.updateProject.bind(this);
    this.scrollToProject = this.scrollToProject.bind(this);
  }

  componentDidMount() {
    let {data, singleProject} = this.props.doc;
    let items = createItems(data.body, singleProject);
    if(this.props.width){
      items = calculateItems(items, this.props.width);
      this.setState({firstLoad: true});
    }
    this.setState({items})
  }

  componentDidUpdate(prevProps){
    if(prevProps.width !== this.props.width ){
      let prevItems = _.cloneDeep(this.state.items);
      let items = calculateItems(prevItems, this.props.width);
      this.setState({ items })
      if(!this.state.firstLoad){
        this.setState({firstLoad: true});
      }
    }
  }

  toggleProject(id, index){
    let items = _.cloneDeep(this.state.items);

    items.forEach(item => {
      if(id === item.id) {
        if(!item.isOpen){
          this.setState({ openItem: item})
        }
        item.isOpen = !item.isOpen;
        item.index = index;
      }
    })

    items = calculateItems(items, this.props.width);
    this.setState({ items })
  }

  scrollToProject(){
    let {openItem} = this.state;
    if(openItem){
      setTimeout(() => {
        animateScrollTo(document.getElementById(openItem.id), {
          offsett: 8,
          speed: 100,
          minDuration: 600,
          maxDuration: 600
        });
        this.setState({openItem: null});
      }, 200);
    }
  }

  updateProject(id, index){
    let items = _.cloneDeep(this.state.items);

    items.forEach(item => {
      if(id === item.id) {
        item.index = index;
      }
    })

    items = calculateItems(items, this.props.width);
    this.setState({ items })
  }

  renderGallery(items){
    return items.map( (item,i) => {
      let {dimension, glyph, id, alt, url, format, retina} = item;
      let style = item.type === "project" ? {zIndex: 200} : {};
      style = item.isOpen ? {zIndex: 400} : {};

      return (
        <div key={i} className="Grid-item" style={{...dimension, ...style}}>
          <div className="Grid-item-inner" style={{...dimension, transition: `all ${animation.letter}ms 50ms`}}>
            { item.type === "glyph" && <Glyph glyph={glyph} size={dimension} /> }
            { item.type === "image" && <Image padding alt={alt} src={url} format={format} retina={retina}/> }
            { item.type === "project" && <Project width={this.props.width} id={id} toggleProject={this.toggleProject} updateProject={this.updateProject} {...item} /> }
          </div>
        </div>
      )
    });
  }

  render(){
    let {items, firstLoad} = this.state;
    return(
      <div className="Gallery">
        { firstLoad ? (
          <MasonryWrapper scrollToProject={this.scrollToProject}>
            {this.renderGallery(items)}
          </MasonryWrapper>
        ) : (
          (<Loader />)
        )}
      </div>
    )
  }
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/Gallery.js